import { getRequest, API } from 'utils/request';

const fetchMentionsList = async () => {
  const res = await getRequest(API.getUsers);
  return res.data.allUserDetails;
};

export { fetchMentionsList };
